import moment from 'moment-timezone';
import useHttp from './use-http';
import { TOTAL_CONVERSIONS_RANGE_ALL, TOTAL_CONVERSIONS_RANGE_WEEK, TIME_SERIES_UNIT_DAY, TIME_SERIES_UNIT_WEEK, TIME_SERIES_UNIT_MONTH, TIME_SERIES_UNIT_QUARTER, TIME_SERIES_UNIT_YEAR } from '../../app-v2/constants/insights';
const useInsights = () => {
    const convertDate = (date) => {
        if (!date) {
            return null;
        }
        return new Date(date).toISOString();
    };
    const getMetrics = (contactId) => {
        const url = `/api/v1/contacts/${contactId}/insights/metrics`;
        const { http } = useHttp();
        return http.get(url);
    };
    const getTimeSeries = (contactId, startDate = null, endDate = null) => {
        const url = `/api/v1/contacts/${contactId}/insights/time-series`;
        const { http } = useHttp();
        return http.get(url, {
            params: {
                start_date: convertDate(startDate),
                end_date: convertDate(endDate)
            }
        });
    };
    const formatTimeSeriesChartDateByUnit = (date, unit = TIME_SERIES_UNIT_DAY, selectedRange = TOTAL_CONVERSIONS_RANGE_ALL, short = false) => {
        if (!date) {
            return '';
        }
        switch (unit) {
            case TIME_SERIES_UNIT_YEAR:
                return moment(date).format('YYYY');
            case TIME_SERIES_UNIT_QUARTER: {
                const quarterFormatted = 'Q' + moment(date).format('Q YYYY');
                return short
                    ? quarterFormatted
                    : quarterFormatted +
                        '<br />' +
                        moment(date).startOf('quarter').format('MMMM D') +
                        '&ndash;' +
                        moment(date).endOf('quarter').format('MMMM D');
            }
            case TIME_SERIES_UNIT_MONTH:
                return short ? moment(date).format('MMMM') : moment(date).format('MMMM YYYY');
            case TIME_SERIES_UNIT_WEEK: {
                let weekFormat = 'D, YYYY';
                if (moment(date).format('MMM') !== moment(date).add('6', 'days').format('MMM')) {
                    weekFormat = 'MMM D, YYYY';
                }
                return moment(date).format('MMM D') + '&ndash;' + moment(date).add('6', 'days').format(weekFormat);
            }
            case TIME_SERIES_UNIT_DAY:
            default:
                if (short) {
                    return selectedRange === TOTAL_CONVERSIONS_RANGE_WEEK
                        ? moment(date).format('dddd')
                        : moment(date).format('MMM D, YYYY');
                }
                return moment(date).format('ddd MMM D, YYYY');
        }
    };
    return {
        getMetrics,
        getTimeSeries,
        formatTimeSeriesChartDateByUnit
    };
};
export default useInsights;
